<template>
	<div class="renderer-page">
		<h1>Claude ad renderer</h1>
		<p>Preview your library with the same cards used in Claude.</p>
		<div v-if="isAuth" class="renderer-controls">
			<label>Theme
				<select aria-label="Theme" v-model="theme"><option value="light">Light</option><option value="dark">Dark</option></select>
			</label>
			<label>Width
				<select aria-label="Width" v-model="width"><option value="900">Wide · 900px</option><option value="390">Narrow · 390px</option></select>
			</label>
			<label>Ads
				<select aria-label="Ads" v-model.number="count" @change="loadAds"><option :value="10">10 ads</option><option :value="1">Single ad</option></select>
			</label>
			<label>Media
				<select aria-label="Media" v-model="mediaType" @change="loadAds">
					<option value="all">All media</option><option value="image">Images</option><option value="video">Videos</option><option value="carousel">Carousels</option>
				</select>
			</label>
			<button type="button" class="btn btn-box" :disabled="loading" @click="loadAds">{{ loading ? 'Loading…' : 'Reload ads' }}</button>
		</div>
		<p v-else>Sign in to preview ads from your workspace.</p>
		<div v-if="isAuth" class="renderer-preview" :data-theme="theme" :style="{ maxWidth: width + 'px' }">
			<Viewer :state="state" :config="config" :bridge="bridge" />
		</div>
	</div>
</template>

<script>
import Viewer from '../../mcp-viewer/viewer.vue';
import filter from '@swipekit/lib/filter';

export default {
	components: { Viewer },
	data: function () {
		return {
			theme: 'light', width: '900', count: 10, mediaType: 'all', loading: false, requestId: 0,
			state: { result: null, error: '' },
			bridge: {
				openLink: function (params) {
					window.open(params.url, '_blank', 'noopener,noreferrer');
					return {};
				},
			},
		};
	},
	computed: {
		isAuth: function () { return this.$store.getters['users/isAuth']; },
		workspaceId: function () {
			const workspace = this.$store.getters['workspaces/all'];
			return this.isAuth && workspace ? workspace.id : null;
		},
		config: function () {
			return {
				assetUrl: this.$store.getters['config/assetUrl'],
				baseUrl: this.$store.getters['config/baseUrl'],
				appUrl: window.location.origin,
			};
		},
	},
	watch: {
		workspaceId: { immediate: true, handler: function () { this.loadAds(); } },
	},
	beforeDestroy: function () { this.requestId += 1; },
	methods: {
		loadAds: async function () {
			const requestId = ++this.requestId;
			this.state.result = null;
			this.state.error = '';
			this.loading = false;
			if (!this.workspaceId) { return; }
			this.loading = true;
			try {
				const ads = await filter({ take: this.count, skip: 0, mediaType: this.mediaType, sort: 'createdAtFirst' }, 'filter-ad');
				if (requestId !== this.requestId) { return; }
				this.state.result = { structuredContent: { data: ads } };
			} catch (error) {
				if (requestId === this.requestId) { this.state.error = 'Could not load your library. Try Reload ads.'; }
			} finally {
				if (requestId === this.requestId) { this.loading = false; }
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.renderer-page { padding: 32px; }
.renderer-controls { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 16px; margin: 24px 0; }
.renderer-controls label { display: flex; flex-direction: column; gap: 6px; }
.renderer-controls select { font: inherit; color: inherit; background: var(--color-bg-2); border: 1px solid var(--color-bg-5); border-radius: 6px; padding: 8px; }
.renderer-preview {
	width: 100%; margin: 0 auto; padding: 16px; border: 1px solid #ddd; border-radius: 12px;
	background: #faf9f5; color-scheme: light;
	--font-sans: system-ui, sans-serif;
	--color-text-primary: #262626; --color-text-secondary: #666; --color-text-info: #4359b8;
	--color-background-primary: #fff; --color-border-primary: #ddd; --color-background-secondary: #f3f3f3; --color-background-tertiary: #ddd;
}
.renderer-preview[data-theme='dark'] {
	background: #1f1e1d; color-scheme: dark; border-color: #454545;
	--color-text-primary: #eee; --color-text-secondary: #bbb; --color-text-info: #a8b4ff;
	--color-border-primary: #454545; --color-background-primary: #252525; --color-background-secondary: #2d2d2d; --color-background-tertiary: #333;
}
@media (max-width: 560px) { .renderer-page { padding: 16px; } .renderer-preview { padding: 8px; } }
</style>
